export enum UserSearchReason {
  HD_VERIFICATION = 'Weryfikacja z powodu zgłoszenia HD',
  OTHER = 'Inne',
  OFFICE_REQUEST_VERIFICATION = 'Weryfikacja na wniosek z innego urzędu',
  USER_REQUEST = 'Na wniosek użytkownika',
  ANNOUNCEMENT_SEND = 'Wysłanie komunikatu',
}
